Directives.DirectMessagingDirective = function DirectMessagingDirective() {

    // @ngInject
    function DirectMessagingDirectiveControllerFunc($scope, $injector, UsersManager, ConversationsManager, WebsocketHelperService,
                                                    $timeout, PopupMessageService, ConversationService, AnalyticsService, AppConfigService,
                                                    moment) {


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'DirectMessagingDirectiveController';

        var self = this;
        this.destroyed = false;
        this.UsersManager = UsersManager;
        this.ConversationService = ConversationService;
        this.ConversationsManager = ConversationsManager;
        this.WebsocketHelperService = WebsocketHelperService;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.$timeout = $timeout;
        this.moment = moment;
        this.UsersManager = UsersManager;
        this.isMalkut = AppConfigService.isMalkutServer();
        this.isProduction = ConversationService.isProduction;
        this.loaded = false;
        this.otherUser = {};


        this.initialize = function initialize() {

            this.updateCurrentUser();

        }.bind(this);

        this.ConversationService.on('openConversation', this.openConversation.bind(this));
        this.ConversationService.on('closeConversation', this.closeChat.bind(this));
        this.ConversationService.on('chatOpened', this.onChatOpened.bind(this));

        this.initialize();
    }

    var DirectMessagingDirectiveController = Class(Controllers.BaseController, {
        constructor: DirectMessagingDirectiveControllerFunc,

        closeChat: function closeChat() {

            this.visible = false;
            this.conversationId = null;
        },


        openConversation: function openConversation(conversationId, isLiveChat) {

            if (isLiveChat) {
                this.closeChat();
                return;
            }
            if (conversationId !== this.conversationId) {
                this.closeChat();
                this.conversationId = conversationId;
                this.minimized = false;
                this.visible = true;
                this.$timeout(function timedOut() {
                    this.ConversationService.updateDirectMessagingConversationId(conversationId);
                }.bind(this), 0);

                this.chatOpened();

            }

        },

        toggleMinimized: function toggleMinimized() {
            this.minimized = !this.minimized;
        },

        updateCurrentUser: function updateCurrentUser() {

            this.user = this.UsersManager.getCurrUser();
        },

        chatOpened: function chatOpened() {
            this.$timeout(function timedOut() {
                this.ConversationService.chatOpened(this.conversationId);
            }.bind(this), 0);

        },

        onChatOpened: function onChatOpened(conversationId) {
            if (conversationId !== this.conversationId) {
                this.closeChat();
            }
        }

    });

    return {
        controller: DirectMessagingDirectiveController,
        bindToController: true,
        controllerAs: 'directMessagingVm',
        restrict: 'AE',
        templateUrl: 'angular/app/modules/core/features/chat/direct_messaging_directive_template.html'
    };
}
;
